import { render, staticRenderFns } from "./User.Verifications.vue?vue&type=template&id=a815f476&scoped=true&"
import script from "./User.Verifications.vue?vue&type=script&lang=js&"
export * from "./User.Verifications.vue?vue&type=script&lang=js&"
import style0 from "./User.Verifications.vue?vue&type=style&index=0&id=a815f476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a815f476",
  null
  
)

export default component.exports